import type {
  NotificationItem,
  NotificationsApiAdapter,
} from "../../common/utils/useNotifications";
import { client } from "../api-client";
import {
  ApiV1ManagementNotificationsListInboxEnum,
  ApiV1ManagementNotificationsMarkAllAsReadPartialUpdateInboxEnum,
} from "../generated-axios-client";

const commentNotificationsAdapter: NotificationsApiAdapter = {
  async fetchNotifications({ ordering, perPage }) {
    const response = await client.apiV1ManagementNotificationsList(
      undefined,
      ApiV1ManagementNotificationsListInboxEnum.Comments,
      undefined,
      ordering,
      perPage
    );
    return { data: { results: response.data.results as unknown as NotificationItem[] } };
  },

  async fetchUnreadCount() {
    const response = await client.apiV1ManagementMeRetrieve();
    return response.data.unread_comment_notifications ?? 0;
  },

  async markAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAsReadPartialUpdate(id);
  },

  async markAllAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
      id,
      ApiV1ManagementNotificationsMarkAllAsReadPartialUpdateInboxEnum.Comments
    );
  },

  async deleteNotification(id) {
    return client.apiV1ManagementNotificationsDestroy(id);
  },
};

export { commentNotificationsAdapter };
